// Persistent strip shown at the very top of the authenticated shell while a
// CloudRadial staff member is operating this tenant via a support-login
// (impersonation) session. Makes the elevated, non-customer session
// unmistakable (DESIGN principle 4 — make the tenant boundary unmistakable) and
// gives a one-click exit. State legibility does not rely on color alone: an icon
// + the literal label "SUPPORT SESSION" carry the meaning (WCAG AA).

import { useState } from 'react';
import { SvgIcon } from '@progress/kendo-react-common';
import { eyeIcon } from '@progress/kendo-svg-icons';
import { useAuth } from '../lib/auth';
import './ImpersonationBanner.css';

export function ImpersonationBanner() {
  const { state, signOut } = useAuth();
  const [exiting, setExiting] = useState(false);

  if (state.status !== 'authenticated' || !state.user.impersonation) {
    return null;
  }

  const { impersonatorEmail } = state.user.impersonation;

  const exit = async () => {
    setExiting(true);
    try {
      // signOut() pings POST /api/auth/logout (which stamps the audit row's
      // EndedUtc for this session) then flips state to anonymous, so RequireAuth
      // bounces to /login.
      await signOut();
    } finally {
      setExiting(false);
    }
  };

  return (
    <div className="impersonation-banner" role="alert">
      <SvgIcon icon={eyeIcon} className="impersonation-banner-icon" aria-hidden="true" />
      <span className="impersonation-banner-tag">SUPPORT SESSION</span>
      <span className="impersonation-banner-text">
        Signed in as <strong>CloudRadial Support</strong> for this tenant
        {' '}&middot;{' '}initiated by {impersonatorEmail}
      </span>
      <button
        type="button"
        className="impersonation-banner-exit"
        onClick={exit}
        disabled={exiting}
      >
        {exiting ? 'Ending…' : 'Exit support session'}
      </button>
    </div>
  );
}
